import { Button } from "components/DesignSystem/Button/Button";
import { Cross } from "components/icons/Cross";
import { DividerLine } from "components/icons/DividerLine";
import { SelectedFloatingControl } from "components/SelectedFloatingControl/SelectedFloatingControl";
import { Table } from "react-table-8.10.7";
import { Task } from "types/Models/task";
import { AllFilingBulkAction } from "./AllFilingBulkAction";

type TableSelectionControlsProps = {
  table: Table<Task>;
  resetSelection: () => void;
  selectedRowsServiceTeam: string[];
  onExportCSV: () => void;
  exportingCsv: boolean;
  canUpdateDeadline: boolean;
};

export const AllFilingBulkActionFloat = ({
  table,
  resetSelection,
  selectedRowsServiceTeam,
  onExportCSV,
  exportingCsv,
  canUpdateDeadline,
}: TableSelectionControlsProps) => {
  const selectedRows = table.getState().rowSelection;

  const allSelectedRows: string[] = Object.entries(selectedRows)
    .filter(([key, value]) => value)
    .map(([key]) => key);

  return (
    <SelectedFloatingControl>
      {allSelectedRows.length > 0 && (
        <>
          <span className="t-whitespace-nowrap t-text-subtext t-text-text-60">
            {allSelectedRows.length} selected
          </span>
          <span className="t-text-neutral-10 t-h-full">
            <DividerLine />
          </span>
          <AllFilingBulkAction
            selectedRows={allSelectedRows}
            resetSelection={resetSelection}
            selectedRowsServiceTeam={selectedRowsServiceTeam}
            onExportCSV={onExportCSV}
            exportingCsv={exportingCsv}
            canUpdateDeadline={canUpdateDeadline}
          />
          <Button
            customType="ghost_icon"
            size="xsmall"
            onClick={resetSelection}
          >
            <Cross />
          </Button>
        </>
      )}
    </SelectedFloatingControl>
  );
};
